import request from "../request";

export default {
  getGantt: (filtros = {}) => {
    return request.get("planificacion/gantt", { params: filtros });
  },
  create: (data) => {
    return request.post("planificacion", data);
  },
  update: (id, data) => {
    return request.put(`planificacion/${id}`, data);
  },
  delete: (id) => {
    return request.delete(`planificacion/${id}`);
  },
};
